import { notifications } from '@mantine/notifications';
import { NotificationProvider } from '@refinedev/core';

export const notificationProvider: NotificationProvider = {
  open: (params) => {
    const colorByType = {
      success: 'teal',
      error: 'red',
      progress: 'yellow',
    } as const;

    notifications.show({
      id: params.key,
      title: params.message,
      message: params.description,
      color: colorByType[params.type],
      position: 'top-right',
      withCloseButton: true,
      autoClose: params.type === 'progress' ? false : 5000,
      withBorder: true,
      styles: {
        description: {
          whiteSpace: 'pre-line',
        },
      },
    });
  },
  close: (key) => {
    notifications.hide(key);
  },
};
